import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";

interface PageContainerProps {
  children: React.ReactNode;
  startColor?: string;
  endColor?: string;
}

const PageContainer: React.FC<PageContainerProps> = ({
  children,
  startColor,
  endColor,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (startColor && endColor) {
      gsap.fromTo(
        containerRef.current,
        { backgroundColor: startColor },
        { backgroundColor: endColor, duration: 2, ease: "power3.out" }
      );
    } else if (startColor) {
      gsap.to(containerRef.current, {
        backgroundColor: startColor,
        duration: 1,
      });
    }
  }, [startColor, endColor]);

  return (
    <div
      ref={containerRef}
      className="flex justify-center md:justify-start flex-col items-center min-h-screen bg-background py-8"
    >
      {children}
    </div>
  );
};

export default PageContainer;
